import React from 'react'
import { Plane, useTexture } from '@react-three/drei'

import * as THREE from 'three'

export default function Ground({
    texturePath,
    repeat = 1,
    width = 30,
    depth = 30,
}) {

    const [
        texture,
    ] = useTexture([
        texturePath,
    ])

    texture.wrapS = texture.wrapT = THREE.RepeatWrapping; 
    texture.repeat.set(repeat, repeat);

    return (
        <Plane
            args={[width, depth]}
            position={[0,-2,0]}
            rotation={[-Math.PI/2,0,0]}
        >
            <meshPhongMaterial map={texture} color="#9aa6a4" />
        </Plane>
    )
}

